import {SubTitle} from "./styled";


export const PageSubTitle = ({ children }) =>{
    return (
        <SubTitle>
            {children}
        </SubTitle>
    );
}